module.exports = __webpack_public_path__ + "img/BIT_white17.baed727a.jpg";